module.exports = __webpack_public_path__ + "static/img/A61801_2.91910cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61801_2.png
// module id = n4LD
// module chunks = 1